enum StatusEnvioSNGPC {
    Pendente = 0,
    Enviado = 1,
    Confirmado = 2,
    Reprovado = 3,
}

export default StatusEnvioSNGPC;